import { FC } from "react";
import PurchaseOrderWebLayout from "./WebLayout";

const PurchaseOrder: FC = () => {
  return (
    <div>
      <PurchaseOrderWebLayout />
    </div>
  );
};

export default PurchaseOrder;
